export default __webpack_public_path__ + "static/media/title.bed71a00.png";